import { StarsButton } from '@ps/web-shared-components';
import React from 'react';

import { TXTWCL_Watch_Trailer } from './WatchTrailerButton.messages.json';

interface Props {
  className?: string;
  disabled?: boolean;
  icon?: JSX.Element;
  onClick?(): void;
}

const WatchTrailerButton: React.FC<Props> = (props) => {
  const { className, disabled, icon, onClick } = props;

  return (
    <StarsButton
      className={className}
      disabled={disabled}
      onClick={onClick}
      translation={{ ...TXTWCL_Watch_Trailer }}
      variant="casino-glass"
      icon={icon}
    />
  );
};

export default WatchTrailerButton;
